export default "query validateEmail ($email:String!){\n    validateEmail(email: $email)\n}\n";